

































import { Component, Vue } from "vue-property-decorator";

@Component
class KYCAuthAction extends Vue {
  link = "";

  dialog = false;

  loading = false;

  async handleStart() {
    this.loading = true;
    try {
      const callback = this.$common.configs.WEB_HOST + "/basis/kyc";
      const res = await this.$store.dispatch(
        "basis/account/loadKYCLink",
        encodeURIComponent(callback)
      );
      this.link = res.url;
      this.dialog = true;
    } catch (error) {
      this.$helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  handleToVerify() {
    window.location.href = this.link;
  }
}
export default KYCAuthAction;
